var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinButton3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_826_14298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint0_radial_826_14298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint1_radial_826_14298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint2_radial_826_14298)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint3_radial_826_14298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2238 52.7305V55.2109H42.466V60.9141H39.3605V55.2109H32.7395V52.7305H49.2238ZM34.5559 51.1094V43.6875H47.3684V51.1094H34.5559ZM37.6223 48.668H44.2434V46.1484H37.6223V48.668ZM65.3285 56.5391V59.0781H48.8246V56.5391H52.7895V54.1953H50.6215V47.8086H60.4457V46.4414H50.602V43.9414H63.5512V50.2695H53.766V51.6758H63.9613V54.1953H61.598V56.5391H65.3285ZM55.8363 56.5391H58.5121V54.1953H55.8363V56.5391ZM70.9449 59.1953C67.6344 59.1953 65.2711 57.3496 65.2418 54.7422H68.9918C69.0211 55.582 69.8316 56.1875 70.9645 56.1875C72.0875 56.1875 72.859 55.5527 72.859 54.6445C72.859 53.7461 71.9703 53.1113 70.6715 53.1016H69.2457V50.5234H70.6715C71.8531 50.5234 72.6734 49.8887 72.6637 49C72.6734 48.1406 71.9801 47.5352 70.984 47.5352C69.9 47.5352 69.109 48.1602 69.0895 49.0391H65.5348C65.5445 46.4707 67.8102 44.6641 70.984 44.6641C74.0895 44.6641 76.2672 46.4023 76.2574 48.7656C76.2672 50.3477 75.0562 51.4316 73.3863 51.6172V51.7344C75.6324 51.9883 76.7945 53.2188 76.7848 54.957C76.7945 57.4375 74.3727 59.1953 70.9449 59.1953ZM92.1863 42.8672V60.9336H89.0809V42.8672H92.1863ZM76.8543 55.6602C78.1238 55.6602 79.5691 55.6602 81.0926 55.6309V54.3613C79.2469 53.9414 78.0457 52.7109 78.0457 51.1094C78.0457 49.0977 79.95 47.6914 82.6355 47.6914C85.3602 47.6914 87.2938 49.0977 87.3035 51.1094C87.2938 52.7012 86.0828 53.9316 84.2176 54.3613V55.5234C85.575 55.4453 86.9227 55.3281 88.2215 55.1523L88.4168 57.457C84.5398 58.1602 80.3895 58.1895 77.2449 58.1797L76.8543 55.6602ZM77.2059 47.1836V44.7617H81.0926V43.0039H84.2371V44.7617H88.1043V47.1836H77.2059ZM81.034 51.1094C81.034 51.8613 81.7078 52.1836 82.6355 52.1836C83.6414 52.1836 84.2957 51.8613 84.2957 51.1094C84.2957 50.3867 83.6414 50.0547 82.6355 50.0352C81.7078 50.0547 81.034 50.3867 81.034 51.1094ZM53.2332 70.6367V73.0586H48.4871V73.8984H55.1668V76.3398H38.6824V73.8984H45.323V73.0586H40.6551V67.4141H53.116V69.8945H43.7605V70.6367H53.2332ZM40.5184 84.8555V79.7773H50.1277V79.2109H40.5379V76.9453H53.2137V81.9062H43.5848V82.5117H53.6434V84.8555H40.5184ZM70.041 66.8672V84.9922H66.916V66.8672H70.041ZM55.6855 80.8516V73.1562H61.1738V70.793H55.6855V68.293H64.377V75.5977H58.9277V78.3027C61.5059 78.2734 63.625 78.1172 65.9199 77.7266L66.1738 80.2461C63.4395 80.7637 60.8027 80.8613 57.3848 80.8516H55.6855ZM86.1848 66.8672V84.9336H83.0012V66.8672H86.1848ZM70.8137 79.5625C75.3156 77.4238 77.1223 74.9434 77.5324 71.1641H71.8488V68.7227H80.716C80.7258 74.377 79.1242 78.8984 72.4152 82.0234L70.8137 79.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_826_14298",
    x: -4,
    y: 0,
    width: 135.04,
    height: 135.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_826_14298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_826_14298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_826_14298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_826_14298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_826_14298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_826_14298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinButton3);
export default __webpack_public_path__ + "static/media/spin-button3.17c1889a12569789232f0cae44990080.svg";
export { ForwardRef as ReactComponent };